import { render, staticRenderFns } from "./EditDetail.vue?vue&type=template&id=de687c2a&scoped=true&"
import script from "./EditDetail.vue?vue&type=script&lang=js&"
export * from "./EditDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditDetail.vue?vue&type=style&index=0&id=de687c2a&lang=scss&scoped=true&"
import style1 from "./EditDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de687c2a",
  null
  
)

export default component.exports